import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Navbar } from '../navbar/navbar';
import { Footer } from '../footer/footer';
import { Loader } from '../shared/loader/loader';
import { ReferralContextService } from './referral-context.service';

@Component({
  selector: 'app-referral-state',
  standalone: true,
  imports: [CommonModule, FormsModule, Navbar, Footer, Loader],
  templateUrl: './referral-state.html',
  styleUrl: './referral.css'
})
export class ReferralState implements OnInit {
  clinicalNotes = '';
  state = '';
  reason = '';
  dea: 'Yes' | 'No' | "Don't know" | '' = '';
  patientSeen: 'Yes' | 'virtual' | 'never' | '' = '';
  submitted = false;
  loading = false;

  CHOICE_STATES = ['NC', 'GA', 'NY'];
  stateOptions = ['NC','GA','TN','MO','AR','OK','AZ','NY'];

  constructor(private ctx: ReferralContextService, private router: Router) {
    const base = ctx.getFormData();
    this.state = (base.stateOfCare || '').toString();
    this.reason = (base.visitReason || '').toString();
    if (this.state) {
      this.reason = this.reason || 'medication';
    }
  }

  private pushDataLayerEvent(eventName: string, payload: Record<string, unknown> = {}): void {
    const normalizedEventName = String(eventName || '').trim();
    if (!normalizedEventName) return;
    try {
      const dataLayer = (window as any).dataLayer = (window as any).dataLayer || [];
      dataLayer.push({
        event: normalizedEventName,
        ...payload
      });
    } catch {}
  }

  ngOnInit(): void {
    this.pushDataLayerEvent('ols_referral_add_details_page');
  }

  get canSend(): boolean {
    return !!this.state && !!this.reason && !this.loading;
  }

  async onSend() {
    this.pushDataLayerEvent('ols_referral_send_button_click');
    this.submitted = true;
    if (!this.state || !this.reason) return;
    this.loading = true;
    const base = this.ctx.getFormData();
    this.ctx.setFormData({
      stateOfCare: this.state,
      visitReason: this.reason
    });
    const fd = new FormData();
    fd.append('Patient_fname', (base.firstname || '').toString());
    fd.append('Patient_Mname', (base.middlename || '').toString());
    fd.append('Patient_lname', (base.lastname || '').toString());
    fd.append('DOB', (base.dob || '').toString());
    fd.append('Birthsex', (base.birthsex || '').toString());
    fd.append('Email', (base.email || '').toString());
    fd.append('Phone', (base.phone || '').toString());
    fd.append('Submission_date', new Date().toLocaleDateString('en-US'));
    fd.append('Provider_fname', (base.submitterFirstName || '').toString());
    fd.append('Provider_lname', (base.submitterLastName || '').toString());
    fd.append('Provider_phone', (base.submitterPhone || '').toString());
    fd.append('Provider_email', (base.Submitteremail || '').toString());
    fd.append('Provider_fax', (base.Submitterfax || '').toString());
    fd.append('Reason', this.reason === 'psychotherapy' ? 'Intake for Psychotherapy' : 'Intake for Medication Management');
    fd.append('State', this.state || '');
    fd.append('DEA', this.dea || '');
    fd.append('Seen_patient', this.patientSeen || '');
    fd.append('Notes_patient', this.clinicalNotes || '');
    fd.append('Affiliated_company', (base.affiliatedCompany || '').toString());
    fd.append('Date_received', this.ctx.getSubmissionDate());
    fd.append('Time_received', this.ctx.getSubmissionTime());
    fd.append('Source_type', 'Referral');
    fd.append('Update_type', 'referral_details');
    try {
      await fetch('https://script.google.com/macros/s/AKfycbzG28eLUEXRigGK7LLv0Z5CSXYHceK7_-kIJYsyCX1ByYGTLjXjDWb5lPfgW1CRJHC3lQ/exec', { method: 'POST', body: fd });
      this.router.navigate(['/referral/success']);
    } catch {
    } finally {
      this.loading = false;
    }
  }

  onStateChange(val: string) {
    this.state = val || '';
    // Default reason to medication when state selected
    if (this.state) this.reason = this.reason || 'medication';
    else this.reason = '';
  }

  onPrevious() { this.router.navigate(['/referral']); }
}


